import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgChatHeart = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.6021 3.00005C11.1051 2.99789 9.63484 3.39638 8.34385 4.15416C7.05286 4.91194 5.98818 6.0014 5.26031 7.30949C4.53243 8.61757 4.16788 10.0966 4.20449 11.5931C4.24109 13.0896 4.67751 14.5491 5.46847 15.82L3.00208 21L8.18206 18.5328C9.28663 19.2198 10.5357 19.641 11.8307 19.763C13.1258 19.885 14.4315 19.7045 15.6449 19.2359C16.8584 18.7672 17.9464 18.0232 18.8232 17.0623C19.7001 16.1015 20.3418 14.9502 20.6978 13.699C21.0539 12.4479 21.1145 11.1312 20.8748 9.85265C20.6352 8.57412 20.1019 7.3687 19.317 6.3314C18.5321 5.2941 17.517 4.45327 16.3517 3.87516C15.1865 3.29706 13.9029 2.99748 12.6021 3.00005V3.00005Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6021 15.4504L9.02208 11.7161C8.70728 11.4021 8.49925 10.997 8.42746 10.5582C8.35567 10.1194 8.42376 9.66919 8.62208 9.27126V9.27126C8.7721 8.97103 8.99134 8.71077 9.26172 8.51192C9.53209 8.31308 9.84586 8.18135 10.1772 8.12759C10.5084 8.07383 10.8478 8.09959 11.1671 8.20274C11.4865 8.30589 11.7768 8.48348 12.0141 8.72086L12.5989 9.30486L13.1837 8.72086C13.4209 8.48364 13.7112 8.3062 14.0305 8.20315C14.3497 8.10009 14.689 8.07438 15.0201 8.12814C15.3513 8.18189 15.665 8.31356 15.9353 8.5123C16.2056 8.71105 16.4248 8.97118 16.5749 9.27126V9.27126C16.7733 9.66916 16.8415 10.1194 16.7697 10.5582C16.6979 10.9971 16.4898 11.4021 16.1749 11.7161L12.6021 15.4504Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgChatHeart.displayName = 'SvgChatHeart';
export default SvgChatHeart;
